export default __webpack_public_path__ + "static/media/background-card-reports.d60a92c0.png";